export default "__VITE_ASSET__mTPhIWQj__"